import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admin--admins--form"
export default class extends Controller {
  static targets = ["form", "companyName"];

  connect() {
    this.updateBreadcrumbUsername();
  }

  updateBreadcrumbUsername() {
    const breadcrumbUsername = document.getElementById("company-name");
    breadcrumbUsername.textContent = this.companyNameTarget.value ?? "―";
  }
}
